import React from 'react';
import { Link } from 'react-router-dom';
import {
  IconArrowRight,
  IconExternalLink,
  IconUsers,
  IconCalendar,
  IconChartBar,
  IconMessage
} from '@tabler/icons-react';
import './SoftwareSolutions.css';

const SoftwareSolutions = () => {
  return (
    <div className="ss-page">
      {/* Hero Section */}
      <section className="ss-hero">
        <div className="ss-hero-content">
          <p className="ss-hero-eyebrow">Software Solutions</p>
          <h1 className="ss-hero-title">
            Technology that powers<br />
            <span className="ss-gradient-text">modern sports</span>
          </h1>
          <p className="ss-hero-description">
            We build custom software for leagues, tournaments, and sports organizations.
            From concept to deployment, our solutions scale with your needs.
          </p>
        </div>
      </section>

      {/* Featured Product */}
      <section className="ss-product">
        <div className="ss-container">
          <div className="ss-product-header">
            <span className="ss-label">Our Platform</span>
            <h2 className="ss-section-title">League Management System</h2>
            <p className="ss-section-description">
              Everything you need to run professional leagues and tournaments.
              Built for performance, designed for ease of use.
            </p>
          </div>

          <div className="ss-features-grid">
            <div className="ss-feature-card">
              <div className="ss-feature-icon">
                <IconUsers size={24} />
              </div>
              <h3>Team &amp; Player Management</h3>
              <p>Comprehensive rosters, profiles, and organization tools for any league size.</p>
            </div>
            <div className="ss-feature-card">
              <div className="ss-feature-icon">
                <IconCalendar size={24} />
              </div>
              <h3>Scheduling &amp; Brackets</h3>
              <p>Automated scheduling, playoff brackets, and tournament management.</p>
            </div>
            <div className="ss-feature-card">
              <div className="ss-feature-icon">
                <IconChartBar size={24} />
              </div>
              <h3>Real-Time Stats</h3>
              <p>Live score updates, statistics tracking, and automatic standings.</p>
            </div>
            <div className="ss-feature-card">
              <div className="ss-feature-icon">
                <IconMessage size={24} />
              </div>
              <h3>Communication</h3>
              <p>Built-in messaging, announcements, and team notifications.</p>
            </div>
          </div>

          <div className="ss-product-cta">
            <Link to="/leagues" className="ss-btn-primary">
              <span>Try it free</span>
              <IconArrowRight size={18} />
            </Link>
            <Link to="/pricing" className="ss-btn-secondary">
              View pricing
            </Link>
          </div>
        </div>
      </section>

      {/* Custom Development */}
      <section className="ss-custom">
        <div className="ss-container">
          <div className="ss-custom-content">
            <span className="ss-label">Services</span>
            <h2 className="ss-section-title">Custom Development</h2>
            <p className="ss-section-description">
              Need something unique? We build bespoke software solutions
              for sports organizations of all sizes. From league platforms to
              video content systems, we bring your vision to life.
            </p>

            <Link to="/newprojects" className="ss-btn-primary">
              <span>Start a project</span>
              <IconArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SoftwareSolutions;
